import _parseInt from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/parse-int";
import "core-js/modules/es6.function.name";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import TabBars from "./tabBars/tabBars.vue";
import Nav from "@/components/nav/navBar.vue";
import UserInfo from "@/components/userInfo/userInfo.vue";
import personality from "./slides/personality.vue";
import futrue from "./slides/futrue.vue";
import { getStatusBarHeight } from "@/utils/statusBarHeight";
import { routerIncludeTimes } from "@/utils/routerStackUtil";
import routerTempHelpers from "@/utils/routerTempHelpers";
import BackTrack from "@/utils/backTrack";
import GeneralUtilsHelper from "@/utils/generalUtils";

var PersonalFutrue =
/*#__PURE__*/
function (_Vue) {
  _inherits(PersonalFutrue, _Vue);

  function PersonalFutrue() {
    var _this;

    _classCallCheck(this, PersonalFutrue);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PersonalFutrue).apply(this, arguments));
    _this.activetedIndex = 0;
    _this.fixedHeight = 0;
    _this.headerHeight = 0;
    _this.bgColor = "#fff";
    _this.swiper = null;
    _this.resultData = {};
    _this.picSrc = "";
    _this.userName = "";
    _this.personalityHeight = 0;
    _this.futrueHeight = 0;
    _this.maxHeight = 0;
    _this.swipeheight = 0;
    _this.isShowTabs = false;
    _this.rateUsSuccessStatus = false;
    return _this;
  }

  _createClass(PersonalFutrue, [{
    key: "onChange",
    value: function onChange(index) {
      this.activetedIndex = index;
    }
  }, {
    key: "clickClose",
    value: function clickClose() {
      var backNum = routerIncludeTimes("personalFutrue");
      this.routerGoBack(-backNum);
      this.removeBackTrack();
    }
  }, {
    key: "addedBackTrack",
    value: function addedBackTrack() {
      var _this2 = this;

      //增加安卓返回键：
      BackTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this2.clickClose();
        }
      });
    }
  }, {
    key: "removeBackTrack",
    value: function removeBackTrack() {
      BackTrack.destroy(this.$route.name);
    }
  }, {
    key: "rateUsSuccess",
    value: function rateUsSuccess() {
      console.log("触发了rateUsSuccess");
      this.rateUsSuccessStatus = true;
    }
  }, {
    key: "changeSwipeHeight",
    value: function changeSwipeHeight(val) {
      // console.log("activetedIndex");
      this.setHeight();
    }
  }, {
    key: "setHeight",
    value: function setHeight() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.futrueHeight = document.querySelector("#futrue").offsetHeight;
        _this3.personalityHeight = document.querySelector("#personality").offsetHeight;

        if (_this3.activetedIndex === 0) {
          _this3.swipeheight = _this3.personalityHeight + 16;
        } else {
          _this3.swipeheight = _this3.futrueHeight;

          if (!_this3.isVip) {
            setTimeout(function () {
              var content = _this3.$refs.scrollContent;
              content.scrollTop = 0;
            }, 0);
          }
        }
      });
    }
  }, {
    key: "setSwiperHeight",
    value: function setSwiperHeight() {
      this.setHeight();
    }
  }, {
    key: "routeChange",
    value: function routeChange(val, oldVal) {
      if (val && oldVal && (oldVal.name === "scaningPhoto" || oldVal.name === "confirmPhoto")) {
        this.activetedIndex = 0;
        this.isShowTabs = false;
        this.bgColor = "#fff";
      }
    }
  }, {
    key: "scrollEvent",
    value: function scrollEvent(e) {
      var scrollTop = e.target.scrollTop;
      var headerEle = document.querySelector("header");
      this.headerHeight = headerEle.offsetHeight;

      if (scrollTop > this.fixedHeight) {
        this.isShowTabs = true;
        this.bgColor = "#6763F8";
      } else {
        this.isShowTabs = false;
        this.bgColor = "#fff";
      }
    }
  }, {
    key: "initData",
    value: function initData() {
      var queryData = routerTempHelpers.getQueryTemp(this.$route.query);

      if (queryData) {
        // console.log("queryData", queryData);
        this.resultData = JSON.parse(queryData.resultData); // console.log('this.resultData',this.resultData)

        this.picSrc = "data:image/jpeg;base64," + queryData.picUrl;
        this.userName = queryData.userName;
      }

      if (!this.isVip) {
        this.rateUsSuccessStatus = false;
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.initData();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this4 = this;

      this.$nextTick(function () {
        var tabBarsEle = document.querySelector(".content-view .tabBars");
        _this4.fixedHeight = tabBarsEle.offsetTop;
        var headerEle = document.querySelector("header");
        _this4.headerHeight = headerEle.offsetHeight;
        _this4.swiper = _this4.$refs.vantswipe; // this.maxHeight =
        //   (document.querySelector("#personalFutrue .content-view") as HTMLElement)
        //     .offsetHeight -
        //   (document.querySelector(".van-swipe") as HTMLElement).offsetTop;
        // console.log("this.minHeight", this.maxHeight);
        // 禁止往上滚动

        var content = _this4.$refs.scrollContent;
        var startY;
        content.addEventListener("touchstart", function (e) {
          startY = e.touches[0].clientY;
        });
        content.addEventListener("touchmove", function (e) {
          var status = "11";
          var ele = content;
          var currentY = e.touches[0].clientY;

          if (ele.scrollTop === 0) {
            status = ele.offsetHeight >= ele.scrollHeight ? "00" : "01";
          } else if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) {
            status = "10";
          }

          if (status !== "11") {
            var direction = currentY - startY > 0 ? "10" : "01";

            if (!(_parseInt(status, 2) & _parseInt(direction, 2))) {
              e.preventDefault();
            }
          }
        });
      });
    }
  }, {
    key: "activated",
    value: function activated() {
      this.initData();
      this.setHeight();
      this.addedBackTrack();
    }
  }, {
    key: "overflowSwitch",
    get: function get() {
      console.log("overflowSwitch:", this.activetedIndex === 1 && !this.isVip && !this.rateUsSuccessStatus);
      return this.activetedIndex === 1 && !this.isVip && !this.rateUsSuccessStatus;
    }
  }, {
    key: "isVip",
    get: function get() {
      return GeneralUtilsHelper.isVip();
    }
  }, {
    key: "androidStatusBarHeight",
    get: function get() {
      return getStatusBarHeight();
    }
  }]);

  return PersonalFutrue;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], PersonalFutrue.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Watch("activetedIndex")], PersonalFutrue.prototype, "changeSwipeHeight", null);

tslib_1.__decorate([Watch("$route")], PersonalFutrue.prototype, "routeChange", null);

PersonalFutrue = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    TabBars: TabBars,
    UserInfo: UserInfo,
    personality: personality,
    futrue: futrue
  },
  name: "personalFutrue"
})], PersonalFutrue);
export default PersonalFutrue;